.potential-problem {
  color: #808080;
}

.last-status {
  color: #808080;
}
